import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import GroupFilter from 'components/search_sidebar/group_filter';

import {
  addPeopleGroupFilterId,
  removePeopleGroupFilterId,
  setPeopleGroupFilterIds
} from "../store/actions/query";
import { delayRetrieveRecords } from "../store/actions/search";

export class PersonGroupFilter extends React.Component {
  static propTypes = {
    addGroupFilterId: PropTypes.func.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    groupByDatabase: PropTypes.bool,
    groups: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      databaseId: PropTypes.number.isRequired,
      databaseName: PropTypes.string.isRequired
    })).isRequired,
    removeGroupFilterId: PropTypes.func.isRequired,
    selectedGroupIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    setGroupFilterIds: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
    totalCount: PropTypes.number.isRequired
  };

  handleGroupSelect = (group) => {
    if (group.id === 'ungrouped') {
      this.props.setGroupFilterIds([group.id]);
    } else if (group.id) {
      this.props.addGroupFilterId(group.id);
    } else {
      this.props.setGroupFilterIds([]);
    }

    this.props.delayRetrieveRecords();
  };

  handleGroupDeselect = (group) => {
    if (group.id) {
      this.props.removeGroupFilterId(group.id);
    }

    this.props.delayRetrieveRecords();
  };

  render() {
    const { addGroupFilterId, delayRetrieveRecords, removeGroupFilterId, setGroupFilterIds, ...props } = this.props;
    return (
      <GroupFilter
        {...props}
        allMembersGroupLabel="All People"
        memberCountProperty="personCount"
        onGroupDeselect={this.handleGroupDeselect}
        onGroupSelect={this.handleGroupSelect}
      />
    );
  }
}

const mapStateToProps = state => ({
  groupByDatabase: state.static.aggregateView,
  groups: state.people.groups,
  selectedGroupIds: state.query.peopleGroupIds,
  totalCount: state.search.meta.people.databaseCount,
  totalUngroupedCount: state.search.meta.people.totalUngroupedCount
});

const mapDispatchToProps = {
  addGroupFilterId: addPeopleGroupFilterId,
  delayRetrieveRecords,
  removeGroupFilterId: removePeopleGroupFilterId,
  setGroupFilterIds: setPeopleGroupFilterIds
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonGroupFilter);
